// eslint-disable-next-line import/prefer-default-export
export const formatToastOption = (
  message: string,
): { duration: number; message: string } => {
  if (message.length > 6) {
    return {
      duration: 2400, // toast 毫秒
      message,
    };
  }
  return {
    duration: 1000, // toast 毫秒
    message,
  };
};
